/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const GlobeIcon = createIcon(
  '0 0 20 20',
  <path
    fillRule="evenodd"
    d="M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0M4.083 11a6 6 0 0 0 3.238 4.37l-.03-.084C6.873 14.12 6.602 12.63 6.523 11zm0-2h2.441c.08-1.63.35-3.12.766-4.286l.031-.084A6 6 0 0 0 4.083 9m4.444 2c.077 1.435.317 2.69.647 3.613.204.571.423.962.617 1.192a.8.8 0 0 0 .209.189.8.8 0 0 0 .21-.19c.193-.229.412-.62.616-1.19.33-.925.57-2.18.647-3.614zm2.946-2H8.527c.077-1.435.317-2.69.647-3.613.204-.571.423-.962.617-1.192A.8.8 0 0 1 10 4.006a.8.8 0 0 1 .21.19c.193.229.412.62.616 1.19.33.924.57 2.18.647 3.614m2.003 2c-.08 1.63-.35 3.12-.767 4.286l-.03.084A6 6 0 0 0 15.917 11zm2.441-2h-2.441c-.08-1.63-.35-3.12-.767-4.286l-.03-.084A6 6 0 0 1 15.917 9"
    clipRule="evenodd"
  />,
);
